module.exports = __webpack_public_path__ + "img/7.aa560469.jpg";